/** Public landing chrome copy (demo English content stays English). */

export interface LandingCapability {
  title: string
  body: string
}

export interface LandingCopy {
  heroTitle: string
  heroSubtitleLines: readonly [string, string, string]
  demoHint: string
  demoReadLabel: string
  demoUnderstandLabel: string
  demoTapHint: string
  demoMeans: string
  demoInContext: string
  demoExampleLabel: string
  demoLocalizedNote: string
  signUpToSave: string
  /** Shown after 2nd demo word tap. Use `{word}` for the English lemma. */
  savedNudge: string
  capabilitiesTitle: string
  capabilitiesSubtitle: string
  capabilities: readonly [
    LandingCapability,
    LandingCapability,
    LandingCapability,
    LandingCapability,
    LandingCapability,
    LandingCapability,
  ]
  finalTitle: string
  getStarted: string
  signIn: string
  footerFaq: string
  footerPrivacy: string
  footerTerms: string
  localeSwitcherLabel: string
}

export function formatLandingWord(template: string, word: string): string {
  return template.replaceAll('{word}', word)
}
